// src/js-dot/frame/template/templates.ts
import { rely } from "@js-dot/frame";
var TemplateTagParser = class {
  /**
   * Check the template has variable expression
   * @param template
   */
  hasVariable(template) {
    return this.getVariables(template).length > 0;
  }
  /**
   * Get Variable Names in template string
   * @param template
   */
  getVariables(template) {
    return this.getToken(template)[1];
  }
};
var TemplateEngine = class {
  #getter;
  /**
   * Template Parser
   */
  parser;
  /**
   * Template Token
   */
  token;
  /**
   * Variable Names
   */
  variableNames;
  static getString(template, values) {
    return new this(template).getString(values);
  }
  constructor(parser, getter_or_template, template) {
    this.parser = parser.constructor.name === "Function" ? rely(parser) : parser;
    let getter = getter_or_template;
    if (typeof getter === "string") {
      template = getter;
      getter = null;
    }
    this.#getter = getter || defaultGetter;
    template && this.setTemplate(template);
  }
  /**
   * Set Template String
   * @param template
   */
  setTemplate(template) {
    this.token = this.parser.getToken(template);
    this.variableNames = this.token[1];
  }
  /**
   * Get Templated String
   * @param values
   */
  getString(values) {
    if (!this.variableNames) {
      throw new ReferenceError("Has not a template string yet.");
    }
    return getTokenizedTemplateString(this.#getter, this.token, values);
  }
};
function defaultGetter(expression, values) {
  return values[expression];
}
function getTokenizedTemplateString(getter, token, values) {
  const [strings, keys, interpolations] = token;
  let result = "";
  const end = strings.length - 1;
  let current = -1;
  while (++current < end) {
    const key = keys[current];
    const value = getter(key, values);
    result += "" + strings[current] + (value === void 0 ? interpolations[current] || key : value);
  }
  return result + strings[end];
}

// src/js-dot/frame/template/double-brace-template.ts
var DoubleBraceTagParser = class extends TemplateTagParser {
  getToken(template) {
    const expressions = [[], [], []];
    const [strings, keys, interpolations] = expressions;
    const end = template.length;
    let current = -1;
    let opened = 0;
    let closed = 0;
    let string = "";
    let key = "";
    while (++current < end) {
      const char = template[current];
      switch (char) {
        case "{":
          if (++opened > 2) {
            opened = 2;
            string += "{";
          }
          continue;
        case "}":
          closed++;
          if (opened === 2 && closed === 2) {
            opened = 0;
            closed = 0;
            strings[strings.length] = string;
            string = "";
            keys[keys.length] = key;
            interpolations[interpolations.length] = "{{" + key + "}}";
            key = "";
          }
          continue;
      }
      if (opened > 1) {
        key += char;
      } else {
        if (opened) {
          string += "{";
          opened = 0;
        }
        if (closed) {
          string += "}";
          closed = 0;
        }
        string += char;
      }
    }
    strings[strings.length] = string + (key ? "{{" + key : "");
    return expressions;
  }
};
var DoubleBraceTemplate = class extends TemplateEngine {
  constructor(template) {
    super(new DoubleBraceTagParser(), template);
  }
};

// src/js-dot/frame/template/sharp-brace-template.ts
var SharpBraceParser = class extends TemplateTagParser {
  getToken(template) {
    const expressions = [[], [], []];
    const [strings, keys, interpolations] = expressions;
    const end = template.length;
    let current = -1;
    let sharped = false;
    let opened = false;
    let string = "";
    let key = "";
    while (++current < end) {
      const char = template[current];
      switch (char) {
        case "#":
          if (sharped) {
            if (opened) {
              opened = false;
              string += "#{" + key;
              key = "";
            } else {
              string += "#";
            }
            opened = false;
            continue;
          }
          sharped = true;
          continue;
        case "{":
          if (sharped) {
            if (opened) {
              sharped = false;
              opened = false;
              string += "#{{" + key;
              key = "";
              continue;
            }
            opened = true;
            continue;
          }
          break;
        case "}":
          if (sharped && opened) {
            sharped = false;
            opened = false;
            const {
              length
            } = strings;
            if (key && !length || string) {
              strings[length] = string;
              string = "";
              keys[keys.length] = key;
              interpolations[interpolations.length] = "#{" + key + "}";
              key = "";
            }
            continue;
          }
      }
      if (opened) {
        key += char;
      } else {
        string += char;
      }
    }
    strings[strings.length] = string + (key ? "#{" + key : "");
    return expressions;
  }
};
var SharpBraceTemplate = class extends TemplateEngine {
  constructor(template) {
    super(new SharpBraceParser(), null, template);
  }
};
export { DoubleBraceTagParser, DoubleBraceTemplate, SharpBraceParser, SharpBraceTemplate, TemplateEngine, TemplateTagParser, getTokenizedTemplateString };
